import * as React from "react";
import "./Attributes.scss";

export interface Attribute {
    value: string;
    label: string;
    url?: string;
    target?: string;
}

export enum AttributeType {
    Text = "text",
    Url = "url"
}

interface AttributesProps {
    attributes: Attribute[];
}

export const Attributes = (props: AttributesProps): JSX.Element => (
    <div className="table">
        {props.attributes.map((attribute: Attribute, i: number) =>
            attribute.label ? (
                <div key={i} className="row">
                    <div className="row-label">{attribute.label}</div>
                    <div className="row-value">{getValue(attribute)}</div>
                </div>
            ) : null
        )}
    </div>
);

const getValue = (attribute) =>
    attribute.url ? (
        <a target={attribute.target} href={attribute.url}>
            {attribute.value}
        </a>
    ) : (
        attribute.value
    );
